/*jshint esversion: 6 */
import Vue from 'vue';
import VueRouter from 'vue-router';
import routeConfig from './router-config';

/* eslint-disable no-new */
Vue.use(VueRouter);

// configure router
const router = new VueRouter({
  // mode: 'history',
  routes: routeConfig
});

// export the router instance
export default router;



// WEBPACK FOOTER //
// ./src/router.js